import { render } from "./TabelaDatatable.vue?vue&type=template&id=770096b2"
import script from "./TabelaDatatable.vue?vue&type=script&lang=js"
export * from "./TabelaDatatable.vue?vue&type=script&lang=js"

import "./TabelaDatatable.vue?vue&type=style&index=0&id=770096b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__